// extracted by mini-css-extract-plugin
var _1 = "GradeGraph__chapter--wN0Dw";
var _2 = "GradeGraph__chapterResponsive--iIEfo GradeGraph__chapter--wN0Dw";
var _3 = "GradeGraph__label--b2nTU";
var _4 = "GradeGraph__main--hHml9";
export { _1 as "chapter", _2 as "chapterResponsive", _3 as "label", _4 as "main" }
